module.exports = __webpack_public_path__ + "static/media/download-light.a3c9aae1.svg";